/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
export const AUDIO_DEVICE_CHANGED = 'AUDIO_DEVICE_CHANGED';
export const AUDIO_DEVICE_DISABLED = 'AUDIO_DEVICE_DISABLED';
export const CLEAN_UP = 'CLEAN_UP';
export const CLOSE_CLICKED = 'CLOSE_CLICKED';
export const CONTINUE_CLICKED = 'CONTINUE_CLICKED';
export const COUNTDOWN_COMPLETE = 'COUNTDOWN_COMPLETE';
export const DEVICES_FOUND = 'DEVICES_FOUND';
export const DEVICE_REQUEST_ACCEPTED = 'DEVICE_REQUEST_ACCEPTED';
export const DEVICE_REQUEST_FAILED = 'DEVICE_REQUEST_FAILED';
export const ERROR_OCCURRED = 'ERROR_OCCURRED';
export const ERROR_CLEARED = 'ERROR_CLEARED';
export const FINISH_CLICKED = 'FINISH_CLICKED';
export const INITIALIZE_WEBCAM = 'INITIALIZE_WEBCAM';
export const MEDIA_RECORDER_INITIALIZED = 'MEDIA_RECORDER_INITIALIZED';
export const MERGED_STREAM_UPDATED = 'MERGED_STREAM_UPDATED';
export const ONCOMPLETE = 'ONCOMPLETE';
export const PAUSE_CLICKED = 'PAUSE_CLICKED';
export const SAVE_CLICKED = 'SAVE_CLICKED';
export const SCREEN_SHARING_DISABLED = 'SCREEN_SHARING_DISABLED';
export const SCREEN_SHARING_ENABLED = 'SCREEN_SHARING_ENABLED';
export const SCREEN_SHARING_ENDED = 'SCREEN_SHARING_ENDED';
export const SCREEN_SHARING_EXTRA_OPTIONS_SET = 'SCREEN_SHARING_EXTRA_OPTIONS_SET';
export const SCREEN_SHARING_TYPE_CHANGED = 'SCREEN_SHARING_TYPE_CHANGED';
export const START_CLICKED = 'START_CLICKED';
export const START_MERGED_STREAM = 'START_MERGED_STREAM';
export const STARTOVER_CLICKED = 'STARTOVER_CLICKED';
export const STOP_MERGED_STREAM = 'STOP_MERGED_STREAM';
export const UNMOUNT_CLEAN_UP = 'UNMOUNT_CLEAN_UP';
export const UPDATE_TIMER = 'UPDATE_TIMER';
export const VIDEO_DEVICE_CHANGED = 'VIDEO_DEVICE_CHANGED';
export const VIDEO_DEVICE_DISABLED = 'VIDEO_DEVICE_DISABLED';
export const VIDEO_OBJECT_GENERATED = 'VIDEO_OBJECT_GENERATED';
export const PICTURE_IN_PICTURE_ENABLED = 'PICTURE_IN_PICTURE_ENABLED';
export const PICTURE_IN_PICTURE_DISABLED = 'PICTURE_IN_PICTURE_DISABLED';
export const SHOW_PIP_MODAL = 'SHOW_PIP_MODAL';
export const HIDE_PIP_MODAL = 'HIDE_PIP_MODAL';
export const TOGGLE_CAMERA_EFFECT = 'TOGGLE_CAMERA_EFFECT';
export const SYSTEM_PERMISSION_ERROR = 'SYSTEM_PERMISSION_ERROR';